require('./OKWizardProgressIndicator.scss');

// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class WizardProgressIndicator extends React.Component {

    buildProgressIndicator = () => {

        const { immSteps, currentStep, stepsAmount } = this.props;

        const result = [];
        const width = `${ 100 / stepsAmount }%`;

        for (let i = 0; i < stepsAmount; i++) {

            const itemName = i + 1;

            const active = currentStep === i;
            const valid = i < currentStep && immSteps.getIn([i, 'isValid']);

            const progressClassName = classNames('ok-wizard-progress-indicator__progress', {
                'ok-wizard-progress-indicator__progress--active': active,
                'ok-wizard-progress-indicator__progress--valid': valid
            });

            const progressItemClassName = classNames('ok-wizard-progress-indicator__item', {
                'ok-wizard-progress-indicator__item--active': active,
                'ok-wizard-progress-indicator__item--valid': valid
            });

            result.push(
                <div key={i} className={progressClassName} style={{ width }}>
                    <span className={progressItemClassName}>
                        {itemName}
                    </span>
                </div>
            )
        }

        return result;
    }

    render() {
        const progressIndicator = this.buildProgressIndicator();
        return (
            <header className="ok-wizard-progress-indicator">
                {progressIndicator}
            </header>
        )
    }
}

WizardProgressIndicator.propTypes = {
    currentStep: PropTypes.number.isRequired,
    stepsAmount: PropTypes.number.isRequired,
    immSteps: PropTypes.object.isRequired
};

module.exports = WizardProgressIndicator;
